module.exports = __webpack_public_path__ + "media/images/lb/976-138ef22d9d8b0c123f9a9e4a54d4c72b.svg";